/* src/app/module/citizen/citizen.component.scss */
/*# sourceMappingURL=citizen.component-UTZO2ZD3.css.map */
